import { HTTP_STATUS } from '@/domains/pjazza/types/consts/HttpStatus.consts.ts'
import { isApiError } from '@/utils/api-error/apiError'

/**
 * Whether a tab call failed because the table is finished with.
 *
 * Two statuses mean it. 404 is a code that no longer opens anything — a slip
 * left on a cleared table. 410 is the server closing the tab underneath this
 * request, which is what a write gets when the till settled the bill while the
 * diner still had the page open. Both mean the same thing to this device:
 * forget the table.
 *
 * Reads `status`, not `data.status`. ApiClient attaches the HTTP status to the
 * error itself and puts Laravel's response body on `data`, and that body has no
 * status key — so the test this replaces was undefined on every branch, the
 * poll never reported a closed tab, and the diner was held on a table the
 * server had already released.
 */
export const isTabGone = (error: unknown): boolean =>
  isApiError(error) && (error.status === HTTP_STATUS.NOT_FOUND || error.status === HTTP_STATUS.GONE)

/** Said to a diner whose table was settled while they were still holding it. */
export const TAB_GONE_MESSAGE = "This table's bill has been settled. Scan the code again to start a new round."
